import React from 'react';
import { RSRadioGroup } from 'reactsymbols-kit';

// reactsymbols-kit types the base component's state as `any`. We narrow the
// only field this override touches rather than re-using that `any`.
interface RadioGroupState {
  selectedValue?: string;
}

type RadioGroupProps = React.ComponentProps<typeof RSRadioGroup>;

/**
 * Subclass of reactsymbols-kit's RSRadioGroup to work around a bug where the
 * selectedValue doesn't update when the selectedValue prop changes.
 *
 * In some cases, this is not enough yet. The easiest solution is then to add a
 * key to force react to instantantiate a new component. This technique is used
 * e.g. in the MethodInspector and DependencyInspector.
 */
class RadioGroup extends RSRadioGroup {
  static getDerivedStateFromProps(props: RadioGroupProps, state: RadioGroupState) {
    if (props.selectedValue !== state.selectedValue) {
      return {
        selectedValue: props.selectedValue,
      };
    } else {
      return null;
    }
  }
}

export default RadioGroup;
